module.exports = __webpack_public_path__ + "static/media/2.42ea6c77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/slides/2.jpg
// module id = 779
// module chunks = 0